export default {
  title: 'Change your username',
  confirmationLabel: 'Confirm your username',
  usernameConfirmation: 'The 2 usernames must be identical',
  informationsLabel: 'The current username is invalid. We recommend that you use an email address as your username.',
};
